export default __webpack_public_path__ + "i18n/translations/translation-en.84aae380.json";